import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './App.css';
import { setClientWidth, endAnimation } from './actions';
import Header from './components/header';
import Footer from './components/footer';
import ScrollToTop from './hoc/scrollToTop';
import Sidebar from './components/sidebar';
import FormsModal from './components/formsModal';
import logo from './images/main/logo.svg';

class App extends Component {
  state = {
    animated: false,
    startTranslating: false,
    headerAnimationStart: false
  }

  updateDimensions() {
    this.props.setClientWidth(document.documentElement.clientWidth);
  }

  componentWillUpdate(nextProps, nextState) {
    document.title = this.getPageTitle(nextProps.location.pathname);
    if (nextProps.location.pathname === "/" && !nextState.startTranslating) {
      setTimeout(() => {
        this.setState({
          startTranslating: true,
          headerAnimationStart: true
        })
      }, 3000);
    }
  }

  componentDidMount() {
    if (this.props.location.pathname === "/" && !this.state.startTranslating) {
      setTimeout(() => {
        this.setState({
          startTranslating: true,
          headerAnimationStart: true
        })
      }, 3000);
    }
    this.updateDimensions();
    document.title = this.getPageTitle(this.props.location.pathname);
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  getPageTitle = (page) => {
    switch (page) {
      case '/':
        return 'Leotrado - cтудия разработки сайтов и мобильных приложений'
      case '/web':
        return 'Cоздание web-приложений, сайтов, интернет-магазинов'
      case '/mobile':
        return 'Разработка мобильных приложений, Android | IOS'
      case '/portfolio':
        return 'Наши работы'
      case '/about':
        return 'О компании LeoTrado'
      case '/blog':
        return 'Блог '
      case '/vacancies':
        return 'Вакансии'
      case '/contacts':
        return 'Контакты'
      case '/agreements':
        return 'Соглашения'
      case '/usage':
        return 'Правила пользования сайтом LeoTrado'
      default:
        return 'Leotrado - cтудия разработки сайтов и мобильных приложений'
    }
  }

  render() {
    let isMain = this.props.location.pathname === "/";
    let { animationIsEnded } = this.props;
    let { headerAnimationStart } = this.state;

    return (
      <div
        className={["App", isMain && !animationIsEnded ? "App-animating" : ""].join(" ")}>
        <Header
          location={this.props.location}
          isMain={isMain}
          headerAnimationStart={headerAnimationStart} />
        {isMain ? animationIsEnded ? null :
          <img
            alt="Leo Trado"
            id="logo_main"
            src={logo}
            className="App__logo App__logo-animation" />
          : null}
        <FormsModal />
        <Sidebar history={this.props.history} />
        <ScrollToTop>
          {this.props.children}
        </ScrollToTop>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = ({
  animationIsEnded
}) => {
  return {
    animationIsEnded
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setClientWidth: (clientWidth) => dispatch(setClientWidth(clientWidth)),
    endAnimation: () => dispatch(endAnimation())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.jsx